import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Env} from '../env';
import {Observable} from 'rxjs/Observable';
import {Menu} from '../models/menu';
import {MenuDto} from '../dto/menu.dto';

@Injectable()
export class MenuService {

  constructor(private http: HttpClient, private global: Env) {}

  getAll(): Observable<Menu[]> {
    const url = this.global.publicMenu;
    return this.http.get(url).map((res: Menu[]) => {
      return res;
    });
  }

  getDetail(id: number): Observable<Menu> {
    const url = this.global.menu + '/' + id;
    return this.http.get(url).map((res: Menu) => {
      return res;
    });
  }

  update(id: number, dto: MenuDto): Observable<Menu> {
    const url = this.global.menu + '/' + id;
    return this.http.post(url, JSON.stringify(dto)).map((res: Menu) => {
      return res;
    });
  }
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/services/menu.service.ts